import { render, staticRenderFns } from "./related_issuable_input.vue?vue&type=template&id=a7e4ee8e&"
import script from "./related_issuable_input.vue?vue&type=script&lang=js&"
export * from "./related_issuable_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports